import {customElement, bindable} from "aurelia-framework";
import {AbstractCell} from './abstract-cell';

@customElement('sio-cell-translated')
export class Translated extends AbstractCell
{
    @bindable column;
    @bindable item;

    _defaultOptions = {
        prefix: '',
    };

    itemChanged()
    {
        this.bind();
    }
}